// src/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './firebase';
import {
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';

// 1) Maak de context
const AuthContext = createContext();

// Custom hook om makkelijker de context te gebruiken
export function useAuth() {
  return useContext(AuthContext);
}

// 2) Provider-component
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Zodra Firebase Auth-status verandert, updaten we currentUser
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  // 3) Helper-functie om uit te loggen
  const logout = () => {
    return signOut(auth);
  };

  // 4) Optioneel: helper voor Google-login
  const loginWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
  };

  // Waarden die je beschikbaar stelt via useAuth()
  const value = {
    currentUser,
    logout,
    loginWithGoogle,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
